import { CountItemsResponse } from '@/modules/index-monitoring-module/services/scientific-analysis-admin-module.dto'
import i18n from '@/lang/i18n'

export interface IndexMonitoringEntities {
    [key: string]: any
}

export enum Column {
    ENTITY = 'index',
    ELASTIC_SEARCH = 'itemsES',
    DATABASE = 'itemsDB',
    QUEUED = 'itemsQueue'
}

export interface IndexMonitoringModuleColumn {
    id: Column,
    translatedName: string
}

export interface IndexMonitoringModuleSummary {
    summary: number,
    columnTranslatedName: string
}

export interface IndexMonitoringModuleState {
    scientificAnalysis: CountItemsResponse[]
    statisticAnalysis: CountItemsResponse[]
    columns: IndexMonitoringModuleColumn[]
}
export const initialIndexMonitoringModuleState =
    (): IndexMonitoringModuleState => ({
        scientificAnalysis: [],
        statisticAnalysis: [],
        columns: [
            {
                id: Column.ENTITY,
                translatedName: i18n.tc('indexMonitoring.entity')
            },
            {
                id: Column.ELASTIC_SEARCH,
                translatedName: i18n.tc('indexMonitoring.elasticSearch')
            },
            {
                id: Column.DATABASE,
                translatedName: i18n.tc('indexMonitoring.dataBase')
            },
            {
                id: Column.QUEUED,
                translatedName: i18n.tc('indexMonitoring.queued')
            }
        ]
    })
